import React from 'react'
import { Link } from "react-router-dom";
function Footer() {
  return (
    <>
      <div className='foot'>
        <div className='container pt-5'>
            <div className='row pt-5'>
                <div className='col-lg-6'>
                    <img width={140} src={require("../image/logo-dark.png")} />
                    <p className='py-3'>In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt.</p>
                    <h5>— SUBSCIBE NOW</h5>
                    <p className='py-2'>Receive News and Offers</p>
                  <form className="d-flex mb-5" role="search">
                    <input className="form-control" type="search" placeholder="Your email" aria-label="Search" />
                    <button type="button" className="btn rounded-end py-2">Subscribe</button>
                 </form>
                 <ul className='pt-5 d-flex foot1 ps-0'>
                    <li><Link to='/' className='ad me-5'>Home</Link></li>
                    <li><Link to='/' className='ad me-5'>Blog</Link></li>
                    <li><Link to='/' className='ad me-5'>Contact</Link></li>
                    <li><Link to='/' className='ad me-5'>Destination</Link></li>  
                    <li><Link to='/' className='ad me-5'>Adventure</Link></li>
                 </ul>
                </div>
                <div className='col-lg-6'>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <h5 className='fw-normal'>Destinations</h5>
                        <ul className='pt-3 foot1 ps-0 text-start'>
                    <li><Link to='/' className='ad'>Africa</Link></li>
                    <li><Link to='/' className='ad'>Oceania</Link></li>
                    <li><Link to='/' className='ad'>Portugal</Link></li>
                    <li><Link to='/' className='ad'>Switzerland</Link></li>
                 </ul>
                        </div>
                        <div className='col-lg-4'>
                            <h5 className='fw-normal mx-4'>Adventures</h5>
                        <ul className='pt-3 foot1 ps-0 text-start mx-4'>
                    <li><Link to='/' className='ad'>The Dead Man</Link></li>
                    <li><Link to='/' className='ad'>The Cursed</Link></li>
                    <li><Link to='/' className='ad'>Rock Climbing</Link></li>
                    <li><Link to='/' className='ad'>Laugavegur</Link></li>
                 </ul>
                        </div>
                        <div className='col-lg-4'>
                            <h5 className='fw-normal'>Information</h5>
                        <ul className='pt-3 foot1 ps-0 text-start'>
                    <li><Link to='/' className='ad'>Miles</Link></li>
                    <li><Link to='/' className='ad'>About US</Link></li>
                    <li><Link to='/' className='ad'>Online Query</Link></li>
                    <li><Link to='/' className='ad'>Become Partner</Link></li>
                    <li><Link to='/' className='ad'>Terms And Condition</Link></li>
                 </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default Footer
